import {URL_BASE_API} from '../configs/urlConfigs';
import {PAGENUMROWS_ACTIVITY_LOG} from '../configs/staticConfigs'; 
import {LBL_EVENT,LBL_SHIFT} from '../configs/labelConfigs'; // LBL_QUOTE

import service from './api';

export const activityLogList = (request) => {  
    let ENDPOINT = '';
    if(request.data!==undefined){ 
        let refType  = request.data.refType;  
        let refId    = request.data.refId; 
        let pageNum  = request.data.page;
        let pageSize = PAGENUMROWS_ACTIVITY_LOG; 
        if(request.data.pageSize) pageSize = request.data.pageSize; 
        // FOR LOGS AGAINST AN EVENT/SHIFT: fetch-logs/?page_size=10&event_id=67 OR &shift_id=182
        if(refType===LBL_EVENT && refId) ENDPOINT = URL_BASE_API+'fetch-logs/?event_id='+refId+'&page='+pageNum+'&page_size='+pageSize;  
        else if(refType===LBL_SHIFT && refId) ENDPOINT = URL_BASE_API+'fetch-logs/?shift_id='+refId+'&page='+pageNum+'&page_size='+pageSize;  
        else if(refType!=='' && refId) ENDPOINT = URL_BASE_API+'fetch-logs/?page='+pageNum+'&page_size='+pageSize+'&'+refType+'='+refId;  
        else ENDPOINT = URL_BASE_API+'fetch-logs/?page='+pageNum+'&page_size='+pageSize; 
    } 
    return service.get(ENDPOINT); 
}; 